import * as models from 'smg/customer-api/models';
import * as paymentmethods from 'smg/customer-api/paymentoptions';
import { Redirect, Session } from 'smg/customer-api/session';
import * as phone from 'smg/phone';
import * as template from 'smg/template';
import * as toast from 'smg/toast';
import { DrawPaymentOption, PromptNewPaymentOption } from '../payments';

void main();

async function main() {
    if (await Redirect()) {
        return;
    }
    const user = await Session().then(s => s.user);
    const cardContainer = document.querySelector<HTMLElement>('#payment-methods-container');

    const newPaymentMethodBtn = document.querySelector('#new-payment-method');
    newPaymentMethodBtn?.addEventListener('click', () => {
        void PromptNewPaymentOption(
            user,
            'Add payment method',
            [
                models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_CREDIT,
            ],
        ).then(resp => {
            if (!resp) {
                return;
            }
            void drawPayment(resp);
        });
    });

    const { paymentOptions } = await paymentmethods.PaymentOptions({
        'data': 'address,' +
            'creditCardFirst6,creditCardLast4,creditCardExpirationDate,key,paymentOptionTypeID,bankType,accountType',
        'sort': 'created asc',
        'q': 'has:email has:phone has:fullName has:addressLine1 has:city has:countryID has:zip valid:yes',
    });

    const drawPayment = async (paymentInit: models.IPaymentOption) => {
        let payment = new models.PaymentOption(paymentInit);
        const paymentEl = (await DrawPaymentOption(payment)).querySelector<HTMLElement>('div');
        const cardEl = template.Clone('#card-template').firstElementChild as HTMLElement;
        const paymentContainer = cardEl.querySelector('.payment-container');
        const editBtn = cardEl.querySelector('.edit-btn');
        const deleteBtn = cardEl.querySelector('.delete-btn');

        paymentContainer?.append(paymentEl as HTMLElement);

        // Checkout drops options whose stored phone fails the server tel validator; let the customer fix it here.
        const applyInvalidPhoneNote = () => {
            paymentContainer?.querySelector('.invalid-phone-note')?.remove();
            if (!phone.IsValid(payment.address.phoneNumber?.phone)) {
                paymentContainer?.append(phone.InvalidPhoneNote());
            }
        };
        applyInvalidPhoneNote();

        editBtn?.addEventListener('click', async () => {
            await PromptNewPaymentOption(user, 'Update', [models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_CREDIT], payment).then(newPayment => {
                if (!newPayment) {
                    return;
                }
                payment = newPayment;
                void DrawPaymentOption(payment, undefined, paymentEl as HTMLElement);
                applyInvalidPhoneNote();
            });
        });

        deleteBtn?.addEventListener('click', () => {
            void paymentmethods.DeletePaymentOption(payment.id || '').
                then(() => {
                    cardEl.parentElement?.removeChild(cardEl);
                    toast.Undo('Removed payment method.', () => paymentmethods.RestorePaymentOption(payment.id || '').then(() => drawPayment(payment)));
                });
        });
        cardContainer?.insertBefore(cardEl, cardContainer.firstChild);
    };
    for (const paymentMethod of paymentOptions) {
        await drawPayment(paymentMethod);
    }
}